import React from 'react';

import { RouteComponentProps, withRouter } from 'react-router-dom';

import { getComponent, getStory } from '../Docs/Docs';
import { RunningHtmlCode } from '../Components/RunningHtmlCode';
import { getKnobValues } from '../Components/CodePreview/KnobsUtils';
import { RunningReactCode } from '../Components/RunningReactCode';
import {
  getComponentName,
  getStoryName,
  getCodeTab,
  getKnobValuesFromUrl,
} from '../Components/Story/StoryPage.utils';

const VisualTestsPage: React.FC<RouteComponentProps> = ({ history, location }) => {
  const componentName = getComponentName(location);
  const component = getComponent(componentName || '');
  if (component === null) {
    return <p>component {componentName} not found</p>;
  }
  const storyName = getStoryName(location);
  const story = getStory(componentName || '', storyName || '');
  if (story === null) {
    return <p>Story {storyName} not found</p>;
  }
  const codeTab = getCodeTab(location, story);

  if (story.coreComponent && story.coreComponent.html && codeTab === 'html') {
    return (
      <div>
        <RunningHtmlCode
          html={story.coreComponent.html}
          events={(component.events || [])
            .map(e => e.name)
            .concat(story.coreComponent.additionalEvents || [])}
          js={story.coreComponent.js || ''}
          knobs={story.coreComponent.knobs || {}}
          knobValues={getKnobValues(
            story.coreComponent.knobs || {},
            getKnobValuesFromUrl(location, story.coreComponent.knobs || {}, 'html'),
          )}
          backgroundVisible={false}
        ></RunningHtmlCode>
      </div>
    );
  }

  if (story.coreComponent_v3 && story.coreComponent_v3.html && codeTab === 'html_v3') {
    return (
      <div>
        <RunningHtmlCode
          html={story.coreComponent_v3.html}
          events={(component.events || [])
            .map(e => e.name)
            .concat(story.coreComponent_v3.additionalEvents || [])}
          js={story.coreComponent_v3.js || ''}
          knobs={story.coreComponent_v3.knobs || {}}
          knobValues={getKnobValues(
            story.coreComponent_v3.knobs || {},
            getKnobValuesFromUrl(location, story.coreComponent_v3.knobs || {}, 'html'),
          )}
          backgroundVisible={false}
        ></RunningHtmlCode>
      </div>
    );
  }

  if (story.reactWrapper && story.coreComponent && codeTab === 'react') {
    return (
      <div>
        <RunningReactCode
          parentJSX={story.reactWrapper.parentJSX || ''}
          jsx={story.reactWrapper.jsx || ''}
          knobs={story.reactWrapper.knobs || {}}
          knobValues={getKnobValues(
            story.reactWrapper.knobs || {},
            getKnobValuesFromUrl(location, story.coreComponent.knobs || {}, 'html'),
          )}
          events={(component.events || [])
            .map(e => e.name)
            .concat(story.coreComponent.additionalEvents || [])}
          backgroundVisible={false}
        />
      </div>
    );
  }

  return <p>No story code found</p>;
};

export default withRouter(VisualTestsPage);
